import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { clearAuthStorage } from "@/lib/api/auth";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

  useEffect(() => {
    // Check if user is authenticated
    const accessToken = localStorage.getItem("accessToken");
    const loginTime = localStorage.getItem("adminLoginTime");

    if (accessToken && loginTime) {
      const loginDate = new Date(loginTime);
      const now = new Date();
      const hoursSinceLogin =
        (now.getTime() - loginDate.getTime()) / (1000 * 60 * 60);

      if (hoursSinceLogin > 24) {
        clearAuthStorage();
        setIsAuthenticated(false);
      } else {
        setIsAuthenticated(true);
      }
    } else {
      clearAuthStorage();
      setIsAuthenticated(false);
    }
  }, []);

  // Show loading state while checking authentication
  if (isAuthenticated === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Render protected content
  return <>{children}</>;
};

export default ProtectedRoute;
